<script setup>
import CareerHeader from '@/Components/Content/Header/Career.vue';
import CourseListItem from '@/Components/List/Item/Course.vue';
import { ref } from 'vue';
import PaginatedList from '@/Components/List/Paginated.vue';
import Default from '@/Layouts/Default.vue';
import Content from '@/Components/Content/index.vue';

const props = defineProps({
  career: {
    type: Object,
    required: true,
  },
  courses: {
    type: Object,
    required: true,
  },
  queryObject: {
    type: Object,
    required: true,
  }
});
const activeTab = ref('about');
</script>

<template>
  <Default>
    <Content content-type="list">
      <template #header>
        <CareerHeader
          v-model="activeTab"
          :page="'courses'"
          :career="career"
        />
      </template>
      <template #content>
        <PaginatedList
          :query-object="queryObject"
          :slug="`career/${career.slug}/${career.id}/courses`"
          list-name="courses"
          :current-page="courses.meta?.page ?? 1"
          :total-results="courses.meta?.total ?? 0"
        >
          <CourseListItem
            v-for="course, index in courses.data"
            :key="`course-${index}`"
            :course="course"
          />
        </PaginatedList>
      </template>
    </Content>
  </Default>
</template>